/**
 * @file functional-requirement.form.tsx
 * @description Форма для создания и редактирования функциональных требований в системе.
 * Включает поля для указания сервиса и группы, к которым относится требование.
 * Позволяет классифицировать функциональность по сервисам и группам.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/dictionary]
 * @related-files [@components/form-controls/dictionary/dictionary.component.tsx]
 */

import { Dictionary } from '@components/form-controls/dictionary';
// import { IFunctionalRequirementDTO } from '@src/types/dto'; // DTO доступно для AI помощников

export const FunctionalRequirementForm = ({ control }: any) => {
    return (
        <div className="flex flex-col gap-[1.0585vmin]">
            <Dictionary label="Сервис" name="service" control={control} />

            <Dictionary label="Группа" name="group" control={control} />
        </div>
    );
};
